import axios from 'axios'
import { BUSCAR_OPCOES_FILTROS_EMISSOES_CTE } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarOpcoesFiltrosEmissaoesCte (empresaId) {

  const url = `${URL}/emissao-cte/opcoes-filtros/${empresaId}`;
  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_OPCOES_FILTROS_EMISSOES_CTE,
        payload: response

      })
  );
}
